import { ChangeDetectorRef, Component, ContentChild, ElementRef, Injector, OnInit, ViewChild } from '@angular/core';
import { endpoints } from 'src/endpoint/endpoints';
import { BaseVisiteComponent } from '../../BaseVisiteComponent';
import { CanComponentDeactivate } from 'src/app/unsaved-changes.guard';
import { Observable } from 'rxjs';
import { gender } from 'src/app/main/administration-panel/domain/gender.enum';
@Component({
  selector: 'app-predittore-scompenso',
  templateUrl: './predittore-scompenso.component.html',
  styleUrls: ['./predittore-scompenso.component.scss']
})
export class PredittoreScompensoComponent extends BaseVisiteComponent implements OnInit {
  gender = gender;

  genereOptions = [{ label: 'Maschio', value: gender.MALE }, { label: 'Femmina', value: gender.FEMALE }, { label: 'Altro', value: gender.OTHER }, { label: 'Sconosciuto', value: gender.UNKNOW }]

  score2OpResult: number | undefined;
  patientData: any;


  constructor(private injector: Injector) {
    super(injector);
  }
  ngOnInit(): void {
    this.clinicalImpressionId = this.pazientiService.getVisita().id;

    // this.patientData = {
    //   age: 80,
    //   sex: 'female',
    //   sbp: 140,
    //   totalCholesterol: 130,
    //   hdlCholesterol: 40,
    //   smoking: true,
    //   diabetes: true
    // };

    // this.calcolaScore2Op(this.patientData);
    // return;

    this.getInvestigations();


  }

  getInvestigations() {
    this.http.get(endpoints.getInvestigation + this.clinicalImpressionId).toPromise()
      .then((resp: any) => {
        const patient = this.pazientiService.getPatient();

        this.patientData = {
          age: patient.extension.find(a => a.url == 'http://hl7.org/fhir/SearchParameter/patient-extensions-Patient-age').valueInteger,
          sex: patient.gender,
          sbp: undefined,
          totalCholesterol: undefined,
          hdlCholesterol: undefined,
          smoking: undefined,
          diabetes: true
        };
        for (const observation of resp) {
          const observationCode = observation.code;

          if (observationCode === "8480-6" && observation.value) {
            this.patientData.sbp = observation.value; // Assumi che il valore sia un numero
          } else if (observationCode === "2093-3" && observation.value) {
            this.patientData.totalCholesterol = observation.value / 38, 67; // Assumi che il valore sia un numero
          } else if (observationCode === "2085-9" && observation.value) {
            this.patientData.hdlCholesterol = observation.value / 38, 67; // Assumi che il valore sia un numero
          } else if (observationCode === "72166-2" && observation.value) {
            this.patientData.smoking = this.getFumatoreFromCode(observation.value); // Assumi che se l'osservazione esiste, il paziente fuma
          }
        }

        if (Object.values(this.patientData).some(value => value === undefined))
          return;
        this.calcolaScore2Op(this.patientData);
        this.patientData.totalCholesterol = this.patientData.totalCholesterol * 38, 67;
        this.patientData.hdlCholesterol = this.patientData.hdlCholesterol * 38, 67;
        this.patientData.totalCholesterol = this.patientData.totalCholesterol.toFixed(0);
        this.patientData.hdlCholesterol = this.patientData.hdlCholesterol.toFixed(0);


      }).catch(err => {
        console.error(err);
        if (err.status == 403) {
          this.toastr.error("Non si dispone dei permessi necessari per eseguire questa operazione.");
          return;
        }
        this.toastr.error('Errore nel caricamento dei Parametri Vitali.');
      });
  }

  calcolaScore2Op(patientData) {


    const baseSurvOp = patientData.sex === 'female' ? 0.808 : 0.758;
    const baseSurv = patientData.sex === 'female' ? 0.9776 : 0.9605;
    const meanLP = patientData.sex === 'female' ? 0.229 : 0.0929;
    const scale1Op = patientData.sex === 'female' ? -0.10 : 0.01;
    const scale1 = patientData.sex === 'female' ? -0.3143 : -0.1565;
    const scale2Op = patientData.sex === 'female' ? 1.10 : 1.25;
    const scale2 = patientData.sex === 'female' ? 0.7701 : 0.8009;


    const lp = this.calcolaLinearPredictor(patientData);
    let risk;
    if (patientData.age >= 70) {
      // Calcolo SCORE2-OP
      const originalRiskOp = 1 - Math.pow(baseSurvOp, Math.exp(lp - meanLP));
      const recalibratedRiskOp = 1 - Math.exp(-Math.exp(scale1Op + scale2Op * Math.log(-Math.log(1 - originalRiskOp))));
      risk = recalibratedRiskOp * 100;
    } else {
      // Calcolo SCORE2 standard
      const originalRisk = 1 - Math.pow(baseSurv, Math.exp(lp));
      const recalibratedRisk = 1 - Math.exp(-Math.exp(scale1 + scale2 * Math.log(-Math.log(1 - originalRisk))));
      risk = recalibratedRisk * 100;
    }

    this.score2OpResult = risk.toFixed(1);
  }

  getGenereLabel(genderValue: string): string {
    const genere = this.genereOptions.find(option => option.value.toLowerCase() === genderValue.toLowerCase());
    return genere ? genere.label : 'Sconosciuto';
  }

  calcolaLinearPredictor(patientData: any): number {

    const { age, sbp, totalCholesterol, hdlCholesterol, smoking, diabetes } = patientData;
    const xcen = { age: 60, sbp: 120, totalCholesterol: 6, hdlCholesterol: 1.3 };
    const xcenOp = { age: 73, sbp: 150, totalCholesterol: 6, hdlCholesterol: 1.4 };
    if (age >= 70) {
      const coefficientiScore2Op = {
        age: patientData.sex === 'female' ? 0.0789 : 0.0634,
        diabetes: patientData.sex === 'female' ? 0.6010 : 0.4245,
        smoking: patientData.sex === 'female' ? 0.4921 : 0.3524,
        sbp: patientData.sex === 'female' ? 0.0102 : 0.0094,
        totalCholesterol: patientData.sex === 'female' ? 0.0605 : 0.085,
        hdlCholesterol: patientData.sex === 'female' ? -0.3040 : -0.356,
        interazioneAgeDiab: patientData.sex === 'female' ? -0.0107 : -0.0174,
        interazioneAgeSmok: patientData.sex === 'female' ? -0.0255 : -0.0247,
        interazioneAgeTotCol: patientData.sex === 'female' ? -0.0009 : 0.0073,
        interazioneAgeSbp: patientData.sex === 'female' ? -0.0004 : -0.0005,
        interazioneAgeHdl: patientData.sex === 'female' ? 0.0154 : 0.0091,
      };
      let lp = 0;
      lp += coefficientiScore2Op.age * (age - xcenOp.age);
      lp += coefficientiScore2Op.sbp * (sbp - xcenOp.sbp);

      lp += coefficientiScore2Op.totalCholesterol * (totalCholesterol - xcenOp.totalCholesterol);

      lp += coefficientiScore2Op.hdlCholesterol * (hdlCholesterol - xcenOp.hdlCholesterol);

      if (diabetes) lp += coefficientiScore2Op.interazioneAgeDiab * ((age - xcenOp.age));

      if (smoking) lp += coefficientiScore2Op.interazioneAgeSmok * ((age - xcenOp.age));

      lp += coefficientiScore2Op.interazioneAgeSbp * ((age - xcenOp.age)) * ((sbp - xcenOp.sbp));

      lp += coefficientiScore2Op.interazioneAgeTotCol * ((age - xcenOp.age)) * ((totalCholesterol) - xcenOp.totalCholesterol);

      lp += coefficientiScore2Op.interazioneAgeHdl * ((age - xcenOp.age)) * (((hdlCholesterol) - xcenOp.hdlCholesterol));

      if (smoking) lp += coefficientiScore2Op.smoking;

      if (diabetes) lp += coefficientiScore2Op.diabetes;


      return lp;
    } else {
      const coefficientiScore2 = {
        age: patientData.sex === 'female' ? 0.4648 : 0.3742,
        diabetes: patientData.sex === 'female' ? 0.8096 : 0.6457,
        smoking: patientData.sex === 'female' ? 0.7744 : 0.6012,
        sbp: patientData.sex === 'female' ? 0.3131 : 0.2777,
        totalCholesterol: patientData.sex === 'female' ? 0.1002 : 0.1458,
        hdlCholesterol: patientData.sex === 'female' ? -0.2606 : -0.2698,
        interazioneAgeDiab: patientData.sex === 'female' ? -0.1272 : -0.0983,
        interazioneAgeSmok: patientData.sex === 'female' ? -0.1088 : -0.0755,
        interazioneAgeSbp: patientData.sex === 'female' ? -0.0277 : -0.0255,
        interazioneAgeTotCol: patientData.sex === 'female' ? -0.0226 : -0.0281,
        interazioneAgeHdl: patientData.sex === 'female' ? 0.0613 : 0.0426,
      };

      let lp = 0;
      lp += coefficientiScore2.age * (age - xcen.age) / 5;
      lp += coefficientiScore2.sbp * (sbp - xcen.sbp) / 20;
      lp += coefficientiScore2.totalCholesterol * ((totalCholesterol) - xcen.totalCholesterol);
      lp += coefficientiScore2.hdlCholesterol * (((hdlCholesterol) - xcen.hdlCholesterol) / 0.5);
      if (diabetes) lp += coefficientiScore2.interazioneAgeDiab * ((age - xcen.age) / 5);
      if (smoking) lp += coefficientiScore2.interazioneAgeSmok * ((age - xcen.age) / 5);
      lp += coefficientiScore2.interazioneAgeSbp * ((age - xcen.age) / 5) * ((sbp - xcen.sbp) / 20);
      lp += coefficientiScore2.interazioneAgeTotCol * ((age - xcen.age) / 5) * ((totalCholesterol) - xcen.totalCholesterol);
      lp += coefficientiScore2.interazioneAgeHdl * ((age - xcen.age) / 5) * (((hdlCholesterol) - xcen.hdlCholesterol) / 0.5);
      if (smoking) lp += coefficientiScore2.smoking;
      if (diabetes) lp += coefficientiScore2.diabetes;


      return lp;
    }
  }

  getFumatoreFromCode(code: string) {
    switch (code) {
      case "LA18976-3":
        return true;
      case "LA18977-1":
        return true;
      case "LA15920-4":
        return false;
      case "LA18978-9":
        return false;
      case "LA18979-7":
        return true;
      case "LA18980-5":
        return false;
      case "LA18981-3":
        return true;
      case "LA18982-1":
        return true;
      default:
        return false;
    }
  }

  getScoreColorClass(): string {
    if (this.score2OpResult !== undefined) {
      if (this.score2OpResult <= 15) {
        return 'green';
      } else if (this.score2OpResult <= 30) {
        return 'yellow';
      } else {
        return 'red';
      }
    }
    return '';
  }


}
